import FacilityApplicationsPage from '@/features/companies/[companyId]/facilities/[facilityId]/persons/page'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_authed/companies/$companySlug/facilities/$facilitySlug/applications/',
)({
  component: FacilityApplicationsPage,
})
